var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 68,
    viewBox: "0 0 172 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_34029_741)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.16 38.744V55H4.2V13.592H22.888V21.336H13.16V31.256H22.248V38.744H13.16ZM50.7975 23.5V47.68C50.7975 52.96 48.3175 55.6 43.3575 55.6H35.3775C30.4175 55.6 27.9375 52.96 27.9375 47.68V23.5C27.9375 18.22 30.4175 15.58 35.3775 15.58H43.3575C48.3175 15.58 50.7975 18.22 50.7975 23.5ZM42.3975 48.64V22.48C42.3975 22.16 42.2775 21.88 42.0375 21.64C41.8375 21.4 41.5775 21.28 41.2575 21.28H37.4775C37.1575 21.28 36.8775 21.4 36.6375 21.64C36.4375 21.88 36.3375 22.16 36.3375 22.48V48.64C36.3375 48.96 36.4375 49.24 36.6375 49.48C36.8775 49.72 37.1575 49.84 37.4775 49.84H41.2575C41.5775 49.84 41.8375 49.72 42.0375 49.48C42.2775 49.24 42.3975 48.96 42.3975 48.64ZM79.86 23.5V47.68C79.86 52.96 77.38 55.6 72.42 55.6H64.44C59.48 55.6 57 52.96 57 47.68V23.5C57 18.22 59.48 15.58 64.44 15.58H72.42C77.38 15.58 79.86 18.22 79.86 23.5ZM71.46 48.64V22.48C71.46 22.16 71.34 21.88 71.1 21.64C70.9 21.4 70.64 21.28 70.32 21.28H66.54C66.22 21.28 65.94 21.4 65.7 21.64C65.5 21.88 65.4 22.16 65.4 22.48V48.64C65.4 48.96 65.5 49.24 65.7 49.48C65.94 49.72 66.22 49.84 66.54 49.84H70.32C70.64 49.84 70.9 49.72 71.1 49.48C71.34 49.24 71.46 48.96 71.46 48.64ZM102.711 13.592C108.001 13.592 110.647 16.408 110.647 22.04V46.552C110.647 52.184 108.001 55 102.711 55H86.2625V13.592H102.711ZM101.687 47.576V20.952C101.687 20.6107 101.559 20.312 101.303 20.056C101.089 19.8 100.812 19.672 100.471 19.672H95.2225V48.856H100.471C100.812 48.856 101.089 48.728 101.303 48.472C101.559 48.216 101.687 47.9173 101.687 47.576Z",
    fill: "#C51D1D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114.64 50.76H118.88V55H114.64V50.76ZM122.179 27H133.819V31H126.579V38.8H132.259V42.8H126.579V55H122.179V27ZM135.929 27H140.329V51H147.569V55H135.929V27ZM149.679 27H154.079V55H149.679V27ZM161.254 40.68L156.414 27H161.054L164.014 36.04H164.094L167.134 27H171.294L166.454 40.68L171.534 55H166.894L163.694 45.24H163.614L160.334 55H156.174L161.254 40.68Z",
    fill: "#C51D1D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_34029_741",
    x: 0.200195,
    y: 9.59198,
    width: 114.446,
    height: 50.008,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.772549 0 0 0 0 0.113725 0 0 0 0 0.113725 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_34029_741"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_34029_741",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0fc02e9ec12df5c5b293ec5dfde87c10.svg";
export { ForwardRef as ReactComponent };